// THIS FILE IS SPECIAL, ALL \`import\`s HERE INCREASE PAGE LOAD TIMES!

// This is the entrypoint for a header.js. This file is to import librares so they are available inside <script> blocks.
// Import anything you plan to use here.
// Minimize the amount of imports here to optimize page load times.

import { Panzoom } from "@fancyapps/ui";
// import { Pins } from "@fancyapps/ui/dist/panzoom/panzoom.pins.esm.js"
import { Toolbar } from "@fancyapps/ui/dist/panzoom/panzoom.toolbar.esm.js";
import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
import { ionRangeSlider } from "@oijs/vanilla-rangeslider";

// Add these objects to the window so they are available in .html files inline <script> blocks
window.jQuery = window.$ = require("jquery");
window.Panzoom = Panzoom;
window.Toolbar = Toolbar;
window.Masonry = Masonry;
window.imagesLoaded = imagesLoaded;
window.ionRangeSlider = ionRangeSlider;
